import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import {
  UpdateLLMProjectInput,
  UpdateLLMProjectMutation,
} from "../API";

export async function updateLLMProjectEnterprise(
  values: UpdateLLMProjectInput
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {

  console.log("updateLLMProjectEnterprise", values);
  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input: {
        id: values.id,
        enterpriseAllowChat: values.enterpriseAllowChat || false,
        enterpriseAcceptableUsePolicy: values.enterpriseAcceptableUsePolicy ? values.enterpriseAcceptableUsePolicy : "",
        enterpriseAccessRequestEmail: values.enterpriseAccessRequestEmail ? values.enterpriseAccessRequestEmail.toLowerCase() : "",
        enterpriseSupportEmail: values.enterpriseSupportEmail ? values.enterpriseSupportEmail.toLowerCase() : "",
        enterpriseDomainWhitelist: values.enterpriseDomainWhitelist  ? values.enterpriseDomainWhitelist.toLowerCase() : "",
        enterpriseTokenBudget: values.enterpriseTokenBudget ? values.enterpriseTokenBudget : 0,
        enterpriseTokenBudgetPeriod: values.enterpriseTokenBudgetPeriod ? values.enterpriseTokenBudgetPeriod : "monthly",
        //enterpriseImageUrl: values.enterpriseImageUrl ? values.enterpriseImageUrl : "",
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
